import { render, staticRenderFns } from "./sxstuinfo.vue?vue&type=template&id=cfa5aff0&scoped=true"
import script from "./sxstuinfo.vue?vue&type=script&lang=js"
export * from "./sxstuinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa5aff0",
  null
  
)

export default component.exports